'use client';

import { useEffect, useState } from 'react';
import { classifyRouteFailure, type RouteFailure } from '@/lib/chunk-load-error';
import { getRunningVersion, reloadOnce } from '@/lib/frontend-version';
import { finishNavigationLoading } from '@/lib/navigation-loading';

const checking: RouteFailure = {
  kind: 'checking',
  deployed: null,
  running: 'dev',
  chunkId: null,
  shouldReload: false,
};

export function useRouteFailure(error: Error & { digest?: string }, logLabel: string): RouteFailure {
  const [failure, setFailure] = useState<RouteFailure>(checking);

  useEffect(() => {
    let cancelled = false;
    finishNavigationLoading();
    void classifyRouteFailure(error).then((result) => {
      console.error(logLabel, {
        message: error.message,
        digest: error.digest,
        kind: result.kind,
        chunkId: result.chunkId,
        running: result.running,
        deployed: result.deployed,
      });
      if (cancelled) return;
      if (result.shouldReload) {
        const versionKey = result.kind === 'update'
          ? `version:${result.deployed}`
          : `chunk:${getRunningVersion()}`;
        reloadOnce(versionKey);
      }
      setFailure(result);
    });
    return () => {
      cancelled = true;
    };
  }, [error, logLabel]);

  return failure;
}
